<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">新規取扱商品</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="block-row">
          <div style="width:35%">
            <h2>検索条件</h2>
            <div class="element-column">
              <div class="column-list">
                <label class="list-input-title">部門</label>
                <div class="list-input-content">
                  <app-class-code-combo-box id="cmb_ClassCode" #cmb_ClassCode [subid]="'cmb_ClassCode'"
                    (keydown)="tabkey_focusEventHandler($event)" [(ngModel)]="kymw1102Model.classCode" [autofocus]="true"
                    [forcedEnabledMode]="'true'" [tabindex]="0">
                  </app-class-code-combo-box>
                </div>

                <label class="list-input-title">バイヤーコード</label>
                <div class="list-input-content">
                  <app-code-combo-box id="cmb_BuyerCode" [subid]="'cmb_BuyerCode'" [(ngModel)]="kymw1102Model.buyerCode"
                    [codeDiv]="'ct357'" [labelField]="'codeValueName'" [forcedEnabledMode]="'true'" [tabindex]="0">
                  </app-code-combo-box>
                  <app-checkbox-label label="仮登録のみ" id="chk_admit" [subid]="'chk_admit'" [forcedEnabledMode]="'true'"
                    [tabindex]="0" [selected]="true" [(ngModel)]="kymw1102Model.admit">
                  </app-checkbox-label>
                </div>
              </div>

              <div class="element-row">
                <button id="btn_View" class="btn-secondary" (click)="eventView_CLICKHandler(null)"
                  (keydown)="tabkey_focusEventHandler($event)" forcedEnabledMode="true" [tabindex]="0">表示</button>
                <button id="btn_Seach" class="btn-secondary" (click)="eventSeach_CLICKHandler(null)"
                  forcedEnabledMode="true" [tabindex]="0">商品検索</button>
              </div>
            </div>
          </div>

          <div style="width:30%">
            <h2>出力設定</h2>
            <div class="element-column">
              <div class="column-list">
                <label class="list-input-title">新商品検討会議</label>
                <div class="list-input-content">
                  <input type="text" style="width:70px" class="text-label-required" id="txt_year" #txt_year [(ngModel)]="kymw1102Model.year"
                    (keydown)="tabkey_focusEventHandler($event)" [maxlength]="4" plessInputTextSub [restrict]="'[0-9]'"
                    forcedEnabledMode="true" [tabindex]="1"/>
                  <label>年</label>
                  <select class="text-label-required" id="cmb_month" [(ngModel)]="kymw1102Model.month"
                    forcedEnabledMode="true" [tabindex]="1">
                    <option value=""></option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </select>
                  <label>月</label>
                  <select class="text-label-required" id="cmb_kai" [(ngModel)]="kymw1102Model.kai"
                    forcedEnabledMode="true" [tabindex]="1">
                    <option value=""></option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                  </select>
                  <label>回</label>
                </div>

                <label class="list-input-title">担当者</label>
                <div class="list-input-content">
                  <app-not-null-text-input id="txt_chargeParson" [subid]="'txt_chargeParson'"
                    [(ngModel)]="kymw1102Model.chargeParson" [displayCountField]="false" [restrict]="'[ -￮]'"
                    [forcedEnabledMode]="'true'" [tabindex]="1">
                  </app-not-null-text-input>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="block-row">
          <div>
            <wj-flex-grid id="dg_selectInfo" #dg_selectInfo [itemsSource]="kymw1102Model.selectInfoList"
              [isReadOnly]="true" [headersVisibility]="'Column'" [allowSorting]="false" [allowDragging]="'None'"
              (selectionChanged)="eventDg_SelectInfo_CHANGEHandler(null)" (keydown)="tabkey_focusEventHandler($event)"
              forcedEnabledMode="true" [tabOrder]="0">
              <wj-flex-grid-column [minWidth]="5" [width]="60" [align]="'center'" [binding]="'selectValue'"
                [header]="'選択'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" [(ngModel)]="cell.item.selectValue" [tabindex]="-1"
                    id="cb_select_info_{{cell.row.index}}" (mouseup)="$event.stopPropagation()" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="90" [binding]="'PCode'" [header]="'Pコード'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" [binding]="'ItemCode'" [header]="'アイテムコード'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="126" [binding]="'GuideGoodsName'" [header]="'商品名'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="140" [binding]="'GuideStandardName'" [header]="'規格名'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="135" [binding]="'MakerName'" [header]="'メーカー名'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="96" [binding]="'ClassNameKanji'" [header]="'部門'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="110" [binding]="'MiddleClassNameKanji'" [header]="'中分類'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="114" [binding]="'SmallClassNameKanji'" [header]="'小分類'">
              </wj-flex-grid-column>
            </wj-flex-grid>
          </div>

          <div>
            <table class="item-detail">
              <tr>
                <th>Ｐコード</th>
                <td>{{kymw1102Model.pcode}}</td>
              </tr>
              <tr>
                <th>アイテムコード</th>
                <td>{{kymw1102Model.itemcode}}</td>
              </tr>
              <tr>
                <th>ＪＡＮコード</th>
                <td>{{kymw1102Model.jancode}}</td>
              </tr>
              <tr>
                <th>商品名</th>
                <td>{{kymw1102Model.goodsname}}</td>
              </tr>
              <tr>
                <th>規格名</th>
                <td>{{kymw1102Model.standardsname}}</td>
              </tr>
              <tr>
                <th>企画回月</th>
                <td>
                  <input type="text" class="item-detail-input" id="txt_kikakumonth" [maxlength]="2" plessInputTextSub
                    [restrict]="'[0-9]'" forcedEnabledMode="true" [tabindex]="0"
                    [(ngModel)]="kymw1102Model.kikakumonth" />
                </td>
              </tr>
              <tr>
                <th>企画回回</th>
                <td>
                  <input type="text" class="item-detail-input" id="txt_kikakukai" [maxlength]="1" plessInputTextSub
                    [restrict]="'[1-5]'" forcedEnabledMode="true" [tabindex]="0" [(ngModel)]="kymw1102Model.kikakukai" />
                </td>
              </tr>
              <tr>
                <th>供給価格</th>
                <td>{{kymw1102Model.supplyprice | number}}</td>
              </tr>
              <tr>
                <th>点数計画</th>
                <td>
                  <input type="text" class="item-detail-input" id="txt_pointplan" #txt_pointplan [maxlength]="10"
                    plessInputTextSub [restrict]="'[0-9]'" forcedEnabledMode="true" [tabindex]="0"
                    [(ngModel)]="kymw1102Model.pointplan" (keydown)="tabkey_focusEventHandler($event)"
                    (focus)="eventTxt_PointPlan_FOCUS_INHandler(null)"
                    (blur)="eventTxt_PointPlan_FOCUS_OUTHandler(null)" />
                </td>
              </tr>
              <tr>
                <th>供給計画</th>
                <td>{{kymw1102Model.supplyPlan}}</td>
              </tr>
              <tr>
                <th>ブランド区分</th>
                <td>{{kymw1102Model.brandkbn}}</td>
              </tr>
              <tr>
                <th>長期保存区分</th>
                <td>{{kymw1102Model.hozonkbn}}</td>
              </tr>
              <tr>
                <th>幅</th>
                <td>{{kymw1102Model.peacewidth}}</td>
              </tr>
              <tr>
                <th>高さ</th>
                <td>{{kymw1102Model.peaceheight}}</td>
              </tr>
              <tr>
                <th>奥行き</th>
                <td>{{kymw1102Model.peacelength}}</td>
              </tr>
              <tr>
                <th>ケース幅</th>
                <td>{{kymw1102Model.casewidth}}</td>
              </tr>
              <tr>
                <th>ケース高さ</th>
                <td>{{kymw1102Model.caseheight}}</td>
              </tr>
              <tr>
                <th>ケース奥行き</th>
                <td>{{kymw1102Model.caselength}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_output" class="btn-primary" (click)="eventOutput_CLICKHandler(null)"
            forcedEnabledMode="true" [tabindex]="1">出力</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button #closebtn [tabindex]="1" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>